export const isSafari = (windowStub?: any) => {
  const _window = windowStub || window

  const userAgent = _window?.navigator?.userAgent
  if (userAgent === undefined) {
    return false
  }

  const isSafari = userAgent.indexOf('Safari') != -1
  const isChrome = userAgent.indexOf('Chrome') != -1
  const isIOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i)
  const webkit = !!userAgent.match(/WebKit/i)
  const isIOSSafari = isIOS && webkit && !userAgent.match(/CriOS/i)

  return (isSafari || isIOSSafari) && !isChrome
}

export const checkIsGoogleChrome = () => {
  const userAgent = navigator.userAgent

  const isEdge = /edge/i.test(userAgent) || /edg/i.test(userAgent)
  const isOpera = /opr/i.test(userAgent) || /Opera/i.test(userAgent)

  return (
    Boolean(window.chrome) &&
    /Chrome/.test(userAgent) &&
    /Google Inc/.test(navigator.vendor) &&
    !isEdge &&
    !isOpera
  )
}
